import type { FormFlow, FmpFormStep } from '../../../types/form'
import { FormTypeEnum } from '@strata-monorepo/shared-types'
import { addressAndMover } from '../questions/addressAndMover'
import { energyPlanIncludes } from '../questions/energyPlanIncludes'
import { homeInfo } from '../questions/homeInfo'
import { termChoice } from '../questions/termChoice'

export const FMP_FORM_NAME = 'fmp_v1'

export const createAddressAtEndQuiz = (): FormFlow => {
  // Step 1: Plan Preferences
  const energyPlanIncludesQuestion = {
    ...energyPlanIncludes,
    componentProps: {
      ...energyPlanIncludes.componentProps,
      tracking: {
        ...energyPlanIncludes.componentProps.tracking,
        deepStepNumber: 1,
        quickStepNumber: 1,
        deepStepId: '1',
        quickStepId: '1',
      },
    },
  }

  // Step 2: Term Length
  const termChoiceQuestion = {
    ...termChoice,
    coreIf: true,
    componentProps: {
      ...termChoice.componentProps,
      canSkip: true,
      tracking: {
        ...termChoice.componentProps.tracking,
        deepStepNumber: 2,
        quickStepNumber: 2,
        deepStepId: '2',
        quickStepId: '2',
      },
    },
  }

  // Step 3: Address Check
  const addressAndMoverQuestion = {
    ...addressAndMover,
    componentProps: {
      ...addressAndMover.componentProps,
      shouldFetchConsumptionPrediction: true,
      tracking: {
        ...addressAndMover.componentProps.tracking,
        deepStepNumber: 3,
        quickStepNumber: 3,
        deepStepId: '3',
        quickStepId: '3',
      },
    },
  }

  // Step 4: Manual Home Details — only shown when RentCast enrichment fails
  const homeInfoQuestion = {
    ...homeInfo,
    componentProps: {
      ...homeInfo.componentProps,
      shouldFetchConsumptionPrediction: true,
      tracking: {
        ...homeInfo.componentProps.tracking,
        deepStepNumber: 4,
        quickStepNumber: 4,
        deepStepId: '4',
        quickStepId: '4',
      },
    },
  }

  const addressAtEndQuestions: FmpFormStep[] = [
    energyPlanIncludesQuestion,
    termChoiceQuestion,
    addressAndMoverQuestion,
    homeInfoQuestion,
  ]

  return {
    version: FMP_FORM_NAME,
    questions: addressAtEndQuestions,
    formType: FormTypeEnum.ADDRESS_AT_END,
    progressDisplay: { mode: 'step', showSteps: true },
  }
}
